export default __webpack_public_path__ + "static/media/VideoSquare1.8de034f1.mp4";